/**
 * A hook to add the page class to the body.
 *
 * @ignore
 */
import { useEffect } from 'react';
/**
 *
 * # usePageClassName
 *
 * Usage example:
 *
 * ```javascript
 * const SomePage: React.FC = ({ children }) => {
 *   usePageClassName('generic-page');
 *   return (
 *     <div>
 *       Welcome to my Page
 *       <section>{children}</section>
 *     </div>
 *   );
 * };
 * ```
 */
export function usePageClassName(pageType) {
    useEffect(() => {
        document.body.classList.remove('article-page', 'category-page', 'index-page', 'generic-page', 'search-page', 'error-page');
        document.body.classList.add(pageType);
    }, [pageType]);
}
//# sourceMappingURL=usePageClassName.js.map